export const config = {
    apiKey: "AIzaSyAyqQ_N0ky3x_iiqNIhRG5VzAInQE565PE",
    authDomain: "bsp-kiosk.firebaseapp.com",
    databaseURL: "https://bsp-kiosk.firebaseio.com",
    projectId: "bsp-kiosk",
    storageBucket: "bsp-kiosk.appspot.com",
    messagingSenderId: "476672427840",
    appId: "1:476672427840:web:36c9ecc8ede1d5aceadca5",
    measurementId: "G-5WLS1WT0HM"
};
